import { GET, POST, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/voucher-theme/${endpoint}`;
};

export const getVoucherThemes = (token, page, pageSize) => {
  let endpoint = getEndpointWithPrefix(`get-all?page=${page}&pageSize=${pageSize}`);
  return GET(endpoint, token);
};

export const getVoucherThemeCategories = (token) => {
  const endpoint = getEndpointWithPrefix(`category`);
  return GET(endpoint, token);
};

export const AddVoucherThemesApi = (token, data) => {
  const endpoint = getEndpointWithPrefix(`add`);
  return POST(endpoint, data, token);
};

export const updateVoucherTheme = (token, data) => {
  const endpoint = getEndpointWithPrefix(`update`);
  return PUT(endpoint, token, data);
};

export const voucherThemeSearchApi = (token, searchKey, searchId, page, pageSize) => {
  const endpoint = getEndpointWithPrefix(`search?searchKey=${searchKey}&searchId=${searchId}&page=${page}&pageSize=${pageSize}`);
  return GET(endpoint, token);
}

export const searchVoucherThemeDropdownList = (token, searchKey, searchId, sortBy, sortDirection) => {
  const endpoint = getEndpointWithPrefix(`get-dropdown-voucherThemes?searchKey=${encodeURIComponent(searchKey)}&searchId=${searchId}&sortBy=${sortBy}&sortDirection=${sortDirection}`);
  return GET(endpoint, token);
};